export default {"src":"/_next/static/media/Apple_logo.9d8ee7f8.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};